import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { FactoryService } from '@services/common/factory.service';
import { Subject, Subscription } from 'rxjs';
import {throttleTime } from 'rxjs/operators';

/**
 * btn debounce check
 * debounceTime: Execute only once within a specified peried
 * debounceClick: function
 */
@Directive({
  standalone: false,
  selector: '[debounceClick]'
})
export class DebounceDirective implements OnInit, OnDestroy {
  @Input() debounceTime: number = 2000;
  // 触发限流后展示toast提示时，控制点击按钮无响应
  @Input() toastControl = false;
  @Output() debounceClick = new EventEmitter();
  private clicks = new Subject();
  private subscription: Subscription;
  constructor(
    private factorySer: FactoryService
  ) { }

  ngOnInit() {
    this.subscription = this.clicks.pipe(throttleTime(this.debounceTime)).subscribe(e => {
      if (!this.toastControl || (!this.factorySer.showToast && this.toastControl)) {
        this.debounceClick.emit(e);
      }
    });
  }

  @HostListener('click', ['$event'])
  clickEvent(event: any) {
    event.preventDefault();
    this.clicks.next(event);
  }

  ngOnDestroy() {
    if (this.subscription) { 
      this.subscription.unsubscribe();
    }
  }
}